import React, { useState, useEffect } from "react"
import "./index.scss"
import { Modal } from "@material-ui/core"
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons"
import ReactPlayer from "react-player"

export default function ImageShowCase(props) {
  const { open, onClose, images, imageSelected, setImageSelected, severalImages, alt } = props

  const handleModalClose = e => {
    if(
      e.target.tagName !== "svg" && 
      e.target.tagName !== "path" &&
      !e.target.classList.contains("imgArrow")
    ) onClose()
  }

  const handleKeyUp = e => {
    if(images.length <= 1) return
    if(e.key === "ArrowRight") setImageSelected(ps => ps === images.length - 1 ? 0 : ps + 1)
    else if(e.key === "ArrowLeft") setImageSelected(ps => ps === 0 ? images.length - 1 : ps - 1)
  }

	return (
		<Modal
			open={open}
			onClose={onClose}
			className="center imageShowcase"
		>
      <div className="modalContent" onClick={handleModalClose} onKeyUp={handleKeyUp}>
        {severalImages && (
          <ArrowBackIos 
            className="imgArrow backward"
            onClick={() => setImageSelected(ps => ps === 0 ? images.length - 1 : ps - 1)}
          />
        )}
        {images[imageSelected]?.type === "video" ? (
          <ReactPlayer 
            url={images[imageSelected]?.src}
            className="imageShowcased"
            playing loop
            onClick={handleModalClose}
          />
        ) : (
          <img
            src={images[imageSelected]?.src}
            alt={alt || images[imageSelected]?.src}
            className="imageShowcased"
          />
        )}
        {severalImages && (
          <ArrowForwardIos 
            className="imgArrow forward"
            onClick={() => setImageSelected(ps => ps === images.length - 1 ? 0 : ps + 1)}
          />
        )}
      </div>
		</Modal>
	)
}
